import React from "react";
import "./Blog_Card.css";
import Read_More_Btn from "../common-btn/read_more_btn/Read_More_Btn";
import { useNavigate } from "react-router-dom";

const Blog_Card = ({
  img,
  authorImg,
  author,
  date,
  title,
  description,
  id,
}) => {
  const navigate = useNavigate();
  const handleBlogClick = (id) => {
    navigate(`/blogs/${id}`);
  };

  return (
    <div className="Blog_Card">
      <div className="img_wrapper">
        <img src={img} className="card_img" alt={title} />
        <div className="author_info">
          <img src={authorImg} className="author_img" alt={author} />
         <span className="author_name">By {author}</span>
        </div>
      </div>
      <div className="card_body">
        <p className="card_date">{date}</p>
        <h5 className="card_title">{title}</h5>
        <p className="card_text">{description}</p>
        <Read_More_Btn
          btnText="Read More"
          onClick={() => handleBlogClick(id)}
        />
      </div>
    </div>
  );
};

export default Blog_Card;
